import { useContext } from 'react'
import { createPortal } from 'react-dom'
import { Fa, Text } from '@eltoro-ui/components'
import { useMediaQuery } from '@eltoro-ui/hooks'
import { ThemeContext } from 'Contexts'

interface SubmissionBlockingOverlayProps {
  show: boolean
  isProcessingPayment?: boolean
}

export const SubmissionBlockingOverlay = ({
  show,
  isProcessingPayment = false,
}: SubmissionBlockingOverlayProps) => {
  const [darkMode] = useMediaQuery('(prefers-color-scheme: dark)')
  const { name: theme } = useContext(ThemeContext)

  const isDarkMode =
    theme === 'darkBlue' ||
    theme === 'dark' ||
    (darkMode && theme === 'default')

  if (!show) return null

  return createPortal(
    <div className="pointer-events-auto fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Backdrop */}
      <div
        className={`absolute inset-0 backdrop-blur-sm ${
          isDarkMode ? 'bg-black/65' : 'bg-black/50'
        }`}
      />

      {/* Content */}
      <div
        className={
          'bg-base relative z-10 flex max-w-[600px] flex-col items-center gap-6 rounded-xl px-16 py-12 text-center shadow-2xl'
        }
      >
        {/* Spinner */}
        <div className={'text-primary text-5xl'}>
          <Fa icon="spinner" animate="spin" size={3} />
        </div>

        {/* Message */}
        <Text className={'m-0 text-2xl font-semibold leading-snug'} tag="h2">
          {isProcessingPayment
            ? 'Processing your payment and submitting your order line(s).'
            : 'Submitting your order line(s).'}
        </Text>

        {/* Warning */}
        <Text className={'m-0 leading-relaxed opacity-90'} tag="p">
          Please do not refresh, close, or leave this page until this process is
          complete.
        </Text>
      </div>
    </div>,
    document.body,
  )
}
